import { forwardRef } from "react";
import { Link, type LinkProps } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { buildLocalizedPath } from "@/lib/i18n";

/**
 * Drop-in replacement for <Link> that rewrites string `to` targets into the
 * currently-active language prefix (e.g. `/contact` → `/pl/contact` when
 * language = PL). Only rewrites teaser routes - always pass a plain app
 * path like `/contact`; the component adds the `/pl` or `/de` prefix
 * based on current language. EN stays unprefixed.
 *
 * Object/function `to` values are passed through unchanged (edge case).
 */
export const LocalizedLink = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to, ...rest }, ref) => {
    const { language } = useLanguage();
    const localizedTo =
      typeof to === "string" ? buildLocalizedPath(to, language) : to;
    return <Link ref={ref} to={localizedTo} {...rest} />;
  }
);

LocalizedLink.displayName = "LocalizedLink";

export default LocalizedLink;
